export default __webpack_public_path__ + "static/media/fix.d0f14857.gif";